module.exports = __webpack_public_path__ + "static/media/36-3.d5a39ecc.mp3";